import { render } from "./shop-details-top.vue?vue&type=template&id=769035dc"
import script from "./shop-details-top.vue?vue&type=script&lang=js"
export * from "./shop-details-top.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__